export default __webpack_public_path__ + "static/media/mode-27.e58594f0.svg";